import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Clients from './components/Clients';
import Footer from './components/Footer';
import About from './pages/About';
import Statement from './components/Statement';
import Services from './components/Services';
import Stats from './components/Stats';
import Contact from './components/Contact';
import ServicesPage from './pages/ServicesPage';
import OurClients from './pages/OurClients';
import ContactUs from './pages/ContactUs';


function ComingSoon() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0f0f0f',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '20px',
      fontFamily: 'sans-serif'
    }}>
      <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>🚧</div>
      <h1 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#ffffff', marginBottom: '1rem' }}>
        Coming Soon
      </h1>
      <p style={{ fontSize: '1.2rem', color: '#aaaaaa', maxWidth: '400px', marginBottom: '0.5rem' }}>
        We're working hard to bring you something amazing.
      </p>
      <p style={{ fontSize: '0.9rem', color: '#555555' }}>
        redoura.com — stay tuned!
      </p>
      <div style={{ display: 'flex', gap: '8px', marginTop: '2.5rem' }}>
        {[0, 150, 300].map((delay) => (
          <div key={delay} style={{
            width: '10px', height: '10px',
            borderRadius: '50%',
            backgroundColor: '#ffffff',
            animation: 'bounce 1s infinite',
            animationDelay: `${delay}ms`
          }}/>
        ))}
      </div>
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}

function TestingPage() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Statement />
      <Services />
      <div className="-mt-4">
        <Clients />
      </div>
      <Stats />
      <Contact />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ComingSoon />} />
        <Route path="/testingpage" element={<TestingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/ourclients" element={<OurClients />} />
        <Route path="/contactus" element={<ContactUs />} />



      </Routes>
    </BrowserRouter>
  );
}

export default App;